import { render } from "./community-rentability-card.vue?vue&type=template&id=570a725a"
import script from "./community-rentability-card.vue?vue&type=script&lang=js"
export * from "./community-rentability-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__